document.addEventListener("DOMContentLoaded", function () {
    const svgWidthInput = document.getElementById("svgWidth");
    const svgHeightInput = document.getElementById("svgHeight");
    const svgPrint = document.getElementById("svg-path");
    const generatePdfButton = document.getElementById("generate-pdf-link");
    const errorMinValue = document.querySelector(".error_message.minvalue");
    const errorMaxValue = document.querySelector(".error_message.maxvalue");
    const maxSizeDisplay = document.getElementById("max-size");
    
    // Plus/Minus Schaltflächen für die Eingabefelder
    const plusButtons = document.querySelectorAll(".size_item-input-button.plus");
    const minusButtons = document.querySelectorAll(".size_item-input-button.minus");

    let aspectRatio = 1; // Standard-Seitenverhältnis
    let lastChanged = "height"; // Beginnen wir mit der Höhe als Ausgangspunkt
    const MAX_WIDTH = 220; // Maximale Breite fest auf 220cm gesetzt

    // Verbesserte Funktion zum Extrahieren der Dimensionen aus dem Variantentitel
    function extractDimensions(variantTitle) {
        // Versuche verschiedene Formate zu erkennen (mit oder ohne Leerzeichen, verschiedene Trennzeichen)
        let match = variantTitle.match(/(\d+[.,]?\d*)\s*(?:cm|CM)\s*(?:x|X|×)\s*(\d+[.,]?\d*)\s*(?:cm|CM)/);
        if (match) {
            // Ersetze Komma durch Punkt für korrekte Konvertierung zu Dezimalzahlen
            const width = parseFloat(match[1].replace(',', '.'));
            const height = parseFloat(match[2].replace(',', '.'));
            return {
                width: width,
                height: height
            };
        }
        return null;
    }

    // Setze die Mindestwerte und Maximalwerte auf feste Standardwerte
    function setMinMaxValues() {
        // Setze feste Standardwerte für min/max
        const minHeight = parseFloat(svgHeightInput.getAttribute("minvalue")) || 10;
        const maxHeight = parseFloat(svgHeightInput.getAttribute("maxvalue")) || 160;
        
        // Berechne die minimale Breite basierend auf der minimalen Höhe und dem Seitenverhältnis
        const minWidth = minHeight * aspectRatio;
        
        svgWidthInput.setAttribute("minvalue", minWidth.toFixed(1));
        svgHeightInput.setAttribute("minvalue", minHeight);
        svgHeightInput.setAttribute("maxvalue", maxHeight);
        svgWidthInput.setAttribute("maxvalue", MAX_WIDTH);
        
        // Aktualisiere das Seitenverhältnis
        updateAspectRatio();
        
        // Setze den Text für die maximale Größe basierend auf dem SVG-Format
        if (maxSizeDisplay) {
            // Berechne die maximale Höhe basierend auf MAX_WIDTH und dem aktuellen Seitenverhältnis
            const calculatedMaxHeight = MAX_WIDTH / aspectRatio;
            // Wähle den kleineren Wert zwischen berechneter Höhe und festgelegter maximaler Höhe
            const effectiveMaxHeight = Math.min(calculatedMaxHeight, maxHeight).toFixed(1);
            // Berechne die maximale Breite basierend auf der effektiven maximalen Höhe und dem Seitenverhältnis
            const effectiveMaxWidth = (effectiveMaxHeight * aspectRatio).toFixed(1);
            
            maxSizeDisplay.textContent = ` ${effectiveMaxWidth}cm x ${effectiveMaxHeight}cm`;
        }
        
        // Da die Höhe bereits im HTML-Template gesetzt wurde (aus der Variante),
        // berechnen wir die Breite basierend auf dieser Höhe und dem Seitenverhältnis
        if (svgHeightInput.value) {
            lastChanged = "height";
            updateDimensions();
        }
        
        // Überprüfe die Werte nach der Initialisierung
        validateDimensions();
    }

    function updateAspectRatio() {
        if (svgPrint && svgPrint.clientWidth > 0 && svgPrint.clientHeight > 0) {
            aspectRatio = svgPrint.clientWidth / svgPrint.clientHeight;
        }
    }

    function updateDimensions() {
        let width = parseFloat(svgWidthInput.value) || 15;
        let height = parseFloat(svgHeightInput.value) || 10;

        if (lastChanged === "width") {
            // Wenn die Breite geändert wurde, berechne die Höhe
            height = width / aspectRatio;
            svgHeightInput.value = height.toFixed(1);
        } else {
            // Wenn die Höhe geändert wurde, berechne die Breite
            width = height * aspectRatio;
            svgWidthInput.value = width.toFixed(1);
        }
        
        // Überprüfe die Dimensionen nach jeder Änderung
        validateDimensions();
    }
    
    // Neue Funktion zur Validierung der Dimensionen
    function validateDimensions() {
        const width = parseFloat(svgWidthInput.value) || 0;
        const height = parseFloat(svgHeightInput.value) || 0;
        const minWidth = parseFloat(svgWidthInput.getAttribute("minvalue")) || 15;
        const maxWidth = parseFloat(svgWidthInput.getAttribute("maxvalue")) || 220;
        const minHeight = parseFloat(svgHeightInput.getAttribute("minvalue")) || 10;
        const maxHeight = parseFloat(svgHeightInput.getAttribute("maxvalue")) || 160;
        
        let hasError = false;
        
        // Überprüfe auf Mindestwerte
        if (width < minWidth || height < minHeight) {
            if (errorMinValue) {
                errorMinValue.classList.add("active");
            }
            hasError = true;
        } else if (errorMinValue) {
            errorMinValue.classList.remove("active");
        }
        
        // Überprüfe auf Maximalwerte
        if (width > maxWidth || height > maxHeight) {
            if (errorMaxValue) {
                errorMaxValue.classList.add("active");
            }
            hasError = true;
        } else if (errorMaxValue) {
            errorMaxValue.classList.remove("active");
        }
        
        // Setze den Button-Status basierend auf den Fehlern
        if (generatePdfButton) {
            if (hasError) {
                generatePdfButton.classList.add("disabled");
            } else {
                generatePdfButton.classList.remove("disabled");
            }
        }
    }

    // Funktion zum Erhöhen/Verringern der Eingabewerte
    function adjustInputValue(input, increment) {
        const value = parseFloat(input.value) || 0;
        const step = parseFloat(input.getAttribute("step")) || 1;
        const newValue = value + (increment ? step : -step);
        input.value = newValue.toFixed(1);
        
        // Auslösen des input-Events, um die Berechnungen zu aktualisieren
        const event = new Event('input', { bubbles: true });
        input.dispatchEvent(event);
    }

    // Event-Listener für Plus/Minus-Schaltflächen
    plusButtons.forEach(button => {
        button.addEventListener("click", function() {
            const inputCard = this.closest(".size_item-input-card");
            const input = inputCard.querySelector("input");
            if (input) {
                if (input.id === "svgWidth") lastChanged = "width";
                else if (input.id === "svgHeight") lastChanged = "height";
                adjustInputValue(input, true);
            }
        });
    });

    minusButtons.forEach(button => {
        button.addEventListener("click", function() {
            const inputCard = this.closest(".size_item-input-card");
            const input = inputCard.querySelector("input");
            if (input) {
                if (input.id === "svgWidth") lastChanged = "width";
                else if (input.id === "svgHeight") lastChanged = "height";
                adjustInputValue(input, false);
            }
        });
    });

    // Event-Listener für Breite
    svgWidthInput.addEventListener("input", function () {
        lastChanged = "width";
        updateDimensions();
    });

    // Event-Listener für Höhe
    svgHeightInput.addEventListener("input", function () {
        lastChanged = "height";
        updateDimensions();
    });

    // Beobachte Änderungen am SVG-Format und aktualisiere das Seitenverhältnis
    if (svgPrint) {
        new MutationObserver(() => {
            updateAspectRatio();
            updateDimensions();
            
            // Aktualisiere die max-size Anzeige wenn sich das Seitenverhältnis ändert
            if (maxSizeDisplay) {
                const maxHeight = parseFloat(svgHeightInput.getAttribute("maxvalue")) || 160;
                const calculatedMaxHeight = MAX_WIDTH / aspectRatio;
                const effectiveMaxHeight = Math.min(calculatedMaxHeight, maxHeight).toFixed(1);
                const effectiveMaxWidth = (effectiveMaxHeight * aspectRatio).toFixed(1);
                maxSizeDisplay.textContent = ` ${effectiveMaxWidth}cm x ${effectiveMaxHeight}cm`;
            }
            
            // Aktualisiere die minimale Breite basierend auf dem neuen Seitenverhältnis
            const minHeight = parseFloat(svgHeightInput.getAttribute("minvalue")) || 10;
            const minWidth = minHeight * aspectRatio;
            svgWidthInput.setAttribute("minvalue", minWidth.toFixed(1));
            
            // Überprüfe die Dimensionen nach der Aktualisierung
            validateDimensions();
        }).observe(svgPrint, { attributes: true, childList: true, subtree: true });
    }

    // MutationObserver für Änderungen an den Input-Werten durch andere Scripte
    const observer = new MutationObserver(() => {
        if (lastChanged === "width") {
            const height = parseFloat(svgWidthInput.value) / aspectRatio;
            svgHeightInput.value = height.toFixed(1);
        } else {
            const width = parseFloat(svgHeightInput.value) * aspectRatio;
            svgWidthInput.value = width.toFixed(1);
        }
        
        // Überprüfe die Dimensionen nach der Aktualisierung
        validateDimensions();
    });
    observer.observe(svgWidthInput, { attributes: true, attributeFilter: ["value"] });
    observer.observe(svgHeightInput, { attributes: true, attributeFilter: ["value"] });

    // Initiales Setzen des Seitenverhältnisses und der Min/Max-Werte
    updateAspectRatio();
    setMinMaxValues();
});